"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Computer;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Computer(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90 17.2H10a2.5 2.5 0 00-2.5 2.5v50.1a2.5 2.5 0 002.5 2.5h80a2.5 2.5 0 002.5-2.5V19.7a2.5 2.5 0 00-2.5-2.5zm-2.5 5v34.19h-75V22.2zm0 45.1h-75v-5.91h75z",
    className: "cls-1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.4 66.57a2.43 2.43 0 10-2.4-2.43 2.43 2.43 0 002.4 2.43zM63.48 78.6H37.17a2.5 2.5 0 000 5h26.31a2.5 2.5 0 100-5z",
    className: "cls-1"
  }))));
}